const UUID_PATTERN = /^[0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12}$/i;

const isUuidLike = (value: string): boolean => UUID_PATTERN.test(value?.trim() ?? "");

export const filterNamedPersonas = (personas: Array<string> | null | undefined): Array<string> =>
  (personas ?? []).filter((persona) => Boolean(persona?.trim()) && !isUuidLike(persona));
